import selectEvent from '%evp_ticket_frontend/js/redux/currentEvent/selectors/selectEvent';
import { openSnackbar, VARIANT_ERROR } from '%app/js/common/components/material/Snackbar';
import {
    SEAT_PURCHASE_STATUS_PURCHASED,
    SEAT_PURCHASE_STATUS_RESERVED,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import Translator from '%app/js/common/services/translator';
import setWaitingHallUpdate from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/setWaitingHallUpdate';
import selectCurrentOrder from '%evp_ticket_frontend/js/redux/currentOrder/selectors/selectCurrentOrder';
import resolveUserPurchasedReservations from '../service/resolveUserPurchasedReservations';
import seatingsClient from '../service/SeatingsClient';
import setSeatsPurchaseStatus from './setSeatsPurchaseStatus';
import setSubscriptionsOnSaleAsAvailable from './setSubscriptionsOnSaleAsAvailable';

function initializeSubscriptionsOnSale() {
    return async (dispatch, getState) => {
        const event = selectEvent(getState());
        const order = selectCurrentOrder(getState());
        if (!event || !order) {
            return;
        }
        const { user_id: userId } = order;
        try {
            for await (const subscriptionsOnSale of seatingsClient.getSubscriptionsOnSale(event.token)) {
                const seatings = subscriptionsOnSale.map(({ seating, user_id: buyerId }) => ({
                    ...seating,
                    user: buyerId,
                }));
                dispatch(setSubscriptionsOnSaleAsAvailable(seatings));
                const { userSeats, reservedSeats } = resolveUserPurchasedReservations(seatings, userId);
                if (userSeats.length > 0) {
                    dispatch(setSeatsPurchaseStatus({
                        seats: userSeats,
                        status: SEAT_PURCHASE_STATUS_RESERVED,
                    }));
                }
                if (reservedSeats.length > 0) {
                    dispatch(setSeatsPurchaseStatus({
                        seats: reservedSeats,
                        status: SEAT_PURCHASE_STATUS_PURCHASED,
                    }));
                }
            }
        } catch (error) {
            if (error?.response?.status < 500) {
                dispatch(openSnackbar({
                    variant: VARIANT_ERROR,
                    message: Translator.trans(error.response.data.error_description),
                }));
            } else {
                throw error;
            }
        } finally {
            dispatch(setWaitingHallUpdate(false));
        }
    };
}

export default initializeSubscriptionsOnSale;
